import React from 'react'
import './footer.css'

const Footer = () => {
  return (
    <div className="footerSection">
      <div className="container">
        <div className="row">
          <div className="col-12 col-md-6 col-lg-4 copyright">
            <img src="images/assets/logo.svg" alt='logo' width={"188"}  />
            <p>Copyright © 2024 Cloudegy, All Rights Reserved</p>
          </div>
          <div className="col-12 col-md-6 col-lg-8 text-right">
              <div className="socialMedia">
                <a href="#"><img src="images/assets/fb.png" alt='facebook' width={"37"} /></a>
                <a href="#"><img src="images/assets/tw.png" alt='Twitter' width={"37"} /></a>
                <a href="#"><img src="images/assets/insta.png" alt='InstaGram' width={"37"} /></a>
                <a href="#"><img src="images/assets/youtube.png" alt='youtube' width={"37"} /></a>
              </div>
              <div className="footerLinks">
                <a href="#" className="active">Developers</a>
                <a href="#">Terms of Service</a>
                <a href="#">Privacy Policy</a>
                <a href="#">Contact Us</a>
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer